export type Attachment = {
  uuid: string;
  url: string;
  isImage: boolean;
  id: number;
  fileName: string;
  createdAt: Date;
  contentType: string;
  type: string;
  user: {
    id: number;
  };
};

export enum AttachmentFilesTypes {
  IMAGE = 'image',
  AUDIO = 'audio',
  VIDEO = 'video',
  CSV = 'csv',
  PDF = 'pdf',
  ARCHIVE = 'archive',
  MSPPT = 'msppt',
  MSWORD = 'msword',
  MSEXCEL = 'msexcel',
  FILE = 'file',
}
